<app-anonymous-page-layout>
  <ng-container *ngIf="showLoginForm()">
    <app-card class="card">
      <app-page-title [title]="'PAGE.LOGIN.TITLE' | translate" style="--page-title-padding-bottom: var(--size-xl)"></app-page-title>
      @if (wantsToLoginWithEmail()) {
        <div class="login-form">
          <form class="form-layout" [formGroup]="emailForm" (ngSubmit)="loginWithEmail()">
            <app-form-element
              class="item"
              [label]="'LABEL.EMAIL' | translate"
              inputId="email"
              [errors]="emailFormHelper.getErrors('email')"
            >
              <mat-form-field>
                <input
                  matInput
                  [placeholder]="'PAGE.LOGIN.ENTER_EMAIL' | translate"
                  id="email"
                  type="email"
                  required
                  autofocus
                  [formControl]="emailForm.controls.email"
                />
              </mat-form-field>
            </app-form-element>
            <app-button
              class="item"
              [label]="'PAGE.LOGIN.ACTION.CONTINUE_WITH_EMAIL' | translate"
              [disabled]="isLoggingIn()"
              [stretched]="true"
            ></app-button>
          </form>
        </div>
      } @else {
        <app-button
          [label]="'PAGE.LOGIN.ACTION.CONTINUE_WITH_EMAIL' | translate"
          iconName="mail-01"
          [stretched]="true"
          (click)="continueWithEmail($event)"
        ></app-button>
      }
      @if (passwordLoginEnabled) {
        @if (wantsToLoginWithPassword()) {
          <div class="login-form">
            <form class="form-layout" [formGroup]="passwordForm" (ngSubmit)="loginWithPassword()">
              <app-form-element
                class="item"
                [label]="'LABEL.EMAIL' | translate"
                inputId="password-email"
                [errors]="passwordFormHelper.getErrors('email')"
              >
                <mat-form-field>
                  <input
                    matInput
                    [placeholder]="'PAGE.LOGIN.ENTER_EMAIL' | translate"
                    id="password-email"
                    type="email"
                    required
                    autofocus
                    [formControl]="passwordForm.controls.email"
                  />
                </mat-form-field>
              </app-form-element>
              <app-form-element
                class="item"
                [label]="'LABEL.PASSWORD' | translate"
                inputId="password-password"
                [errors]="passwordFormHelper.getErrors('password')"
              >
                <mat-form-field>
                  <input matInput id="password-password" type="password" required [formControl]="passwordForm.controls.password" />
                </mat-form-field>
              </app-form-element>
              <app-button class="item" [label]="'LABEL.SIGN_IN' | translate" [disabled]="isLoggingIn()" [stretched]="true"></app-button>
            </form>
          </div>
        } @else {
          <app-button
            [label]="'PAGE.LOGIN.ACTION.CONTINUE_WITH_PASSWORD' | translate"
            buttonStyle="secondary"
            iconName="eye-off"
            [stretched]="true"
            (click)="continueWithPassword($event)"
          ></app-button>
        }
      }

      <app-button
        buttonStyle="secondary"
        [label]="'PAGE.LOGIN.ACTION.CONTINUE_WITH_GOOGLE' | translate"
        iconName="google"
        [stretched]="true"
        style="--icon-size: var(--size-rg)"
        (click)="loginWithProvider({ type: 'google' }, $event)"
        [disabled]="isUsingInAppBrowser()"
      ></app-button>

      @if (isUsingInAppBrowser()) {
        <div class="info-box">
          {{ 'PAGE.LOGIN.INFO.IN_APP_BROWSER' | translate }}
        </div>
      }

      <!-- TODO: Uncomment to enable login via facebook as soon as this is configured by Swipes. -->
      <!--      <app-button-->
      <!--        buttonStyle="secondary"-->
      <!--        [label]="'PAGE.LOGIN.ACTION.CONTINUE_WITH_FACEBOOK' | translate"-->
      <!--        iconName="facebook"-->
      <!--        [stretched]="true"-->
      <!--        style="&#45;&#45;icon-size: var(&#45;&#45;size-rg)"-->
      <!--        (click)="loginWithProvider({ type: 'facebook' }, $event)"-->
      <!--      ></app-button>-->
    </app-card>
  </ng-container>
</app-anonymous-page-layout>
